import { motion } from "framer-motion";
import { RiRobot2Line, RiLayoutGridLine } from "react-icons/ri";
import { FaRegListAlt, FaGlobe, FaStar } from "react-icons/fa";
import CountUp from "react-countup";

const iconsMap = {
  chatbot: <RiRobot2Line size={32} />,
  category: <FaRegListAlt size={32} />,
  card: <RiLayoutGridLine size={32} />,
  country: <FaGlobe size={32} />,
};

// Animation variants for icons
const iconVariants = {
  bounce: {
    y: [0, -8, 0],
    transition: { duration: 0.7, repeat: Infinity }
  },
  spin: {
    rotate: 360,
    transition: { duration: 1.5, repeat: Infinity, ease: "linear" }
  }
};



const Card = ({ card, index, onClick, count, isActive }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { delay: index * 0.1, type: "spring", stiffness: 120 },
    },
    hover: { scale: 1.05, boxShadow: "0px 15px 25px rgba(0,0,0,0.2)" },
    tap: { scale: 0.95 },
  };

  return (
    <motion.div
      key={card.id}
      custom={index}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      whileTap="tap"
      variants={cardVariants}
      className={`cursor-pointer rounded-xl p-6 text-white flex flex-col justify-between h-48 relative transition
        ${isActive
          ? `bg-gradient-to-r from-gray-600 to-gray-900  ring-2 shadow-xl`
          : `opacity-70 hover:opacity-100 ${card.color}`
        }`}
      onClick={() => onClick(card.id)}
    >
      {/* Active badge */}
      {isActive && (
        <div className="absolute top-1 left-3 bg-white text-gray-800 text-xs font-bold px-2 py-1 rounded shadow">
          Active
        </div>
      )}

      {/* Count Badge */}
      <motion.div
        key={count}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
        className="absolute top-4 right-4 w-16 h-16 rounded-full flex flex-col items-center justify-center 
             bg-gradient-to-r text-white shadow-xl"
      >
        <motion.div
          animate={{ y: [0, -4, 0] }}
          transition={{ repeat: Infinity, duration: 1.2, ease: "easeInOut" }}
        >
          <FaStar className="text-yellow-300 drop-shadow-lg" size={14} />
        </motion.div>
        <CountUp
          end={count || 0}
          duration={0.8}
          separator=","
          className="text-lg font-extrabold"
        />
      </motion.div>


      {/* Icon + Title */}
      <div className="flex items-center gap-3">
        <motion.div
          className="p-2 bg-white/20 rounded-lg"
          animate={isActive ? "spin" : "bounce"}
          variants={iconVariants}
        >
          {iconsMap[card.id]}
        </motion.div>
        <h2 className="text-xl font-semibold">{card.title}</h2>
      </div>

      <p className="mt-2 text-sm">{card.description}</p>

      {/* Button */}
      <div className="mt-auto text-right">
        <button
          className={`mt-3 px-4 border py-2 bg-gradient-to-r text-white rounded-lg shadow hover:bg-blue-700 transition text-sm ${isActive ? " from-indigo-500 to-indigo-900" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            onClick(card.id);
          }}
        >
          Manage →  
        </button>
      </div>
    </motion.div>
  );
};

export default Card;